import { SelectableOptionItem } from '../../Select/Select.types';
import { AddressSuggestion } from '../AddressSearch.types';

export const getAddressSelectableOptions = (
  addressSuggestions: AddressSuggestion[],
): SelectableOptionItem[] => {
  return addressSuggestions.map((addressSuggestion) => {
    return {
      text: `${addressSuggestion.Text} ${addressSuggestion.Description}`,
      dynamicValues: {
        Type: addressSuggestion.Type,
        Id: addressSuggestion.Id,
        Text: addressSuggestion.Text,
      },
    };
  });
};
